module.exports = __webpack_public_path__ + "fonts/Vazir-Bold-FD.9fb7ea1.woff";